import { style } from "@vanilla-extract/css";
import { rem } from "@huub-web/utils/css/rem";

export const containerStyle = style({
  position: "absolute",
  backgroundColor: "red",
  left: "50%",
  bottom: "1px",
  transform: "translate(-50%, 100%)",
  padding: "2px 4px",
  borderRadius: "2px",
  color: "white",
  whiteSpace: "nowrap",
  fontSize: rem(10),
});
